import React from "react";

import "./hint.scss";

export const Hint = props => {
  return <p data-component="hint">{props.children}</p>;
};
